import React, { Component } from 'react'
import { connect } from 'react-redux'
import cx from 'classnames'

import './about-section.scss'

class AboutSection extends Component {
    
    render () {

        const className = cx(
            'about-section-container',
            { open: this.props.isAboutOpen }
        )

        return (
            <section className={className}>
                <h5>What is this?</h5>
                <p>
                    Our XR Directory allows you to find companies that offer virtual, 
                    augmented and mixed reality based services. Its primary goal is to promote the 
                    next-generation immersive technology to bring together VR / AR / MR professionals around the world. 
                    This directory is a non-profit project to strengthen the community and 
                    allow content producers to be found easily.
                </p>
                <h5>Made by</h5>
                <a href="https://delight-vr.com/" target="_blank" rel="noopener noreferrer">
                    <img src="/delight-xr-logo-black.svg" alt="Xymatic logo" />
                </a>
            </section>
        )
    }

}

export default connect(state => ({
    isAboutOpen: state.uiReducer.isAboutOpen
}))(AboutSection)


// WEBPACK FOOTER //
// ./src/components/shared/about-section/index.jsx